<template>
  <div class="gr-logo" v-html="GrLogoLight"></div>
</template>

<script>
import GrLogoLight from './gr_logo_light.svg'
export default {
  data () {
    return {
      GrLogoLight: GrLogoLight
    }
  }
}
</script>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/GrLogoLight.vue